var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"its-Download"},[_c('banner',{attrs:{"banners":_vm.banners,"height":'775px',"tabs":_vm.tabs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }